import { Workflow } from 'lucide-react';
import { TASK_SOURCE_LABELS, type TaskSourceKind } from '@shared/types/task-sources';
import { cn } from '@/lib/utils';

/**
 * SF-T-186: the mark of a tracker a source reads from (GitHub, Asana, Trello; jflo's is a flow), in the
 * text colour. Decorative unless `label` is set, when it's read out as the tracker's name.
 */
export function TrackerIcon({ kind, label = false, className }: { kind: TaskSourceKind; label?: boolean; className?: string }) {
  const a11y = label ? { role: 'img', 'aria-label': TASK_SOURCE_LABELS[kind] } : { 'aria-hidden': true as const };
  const cls = cn('size-4 shrink-0', className);
  if (kind === 'jflo') return <Workflow className={cls} {...a11y} />;
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={cls} {...a11y}>
      {kind === 'github' ? (
        <path d="M12 .3a12 12 0 0 0-3.8 23.38c.6.12.82-.26.82-.58l-.01-2.04c-3.34.72-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.09-.74.08-.73.08-.73 1.2.09 1.84 1.24 1.84 1.24 1.07 1.83 2.81 1.3 3.5 1 .1-.78.42-1.3.76-1.6-2.67-.3-5.47-1.34-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.14-.3-.54-1.52.1-3.18 0 0 1-.32 3.3 1.23a11.5 11.5 0 0 1 6 0c2.28-1.55 3.29-1.23 3.29-1.23.64 1.66.24 2.88.12 3.18a4.65 4.65 0 0 1 1.23 3.22c0 4.61-2.8 5.63-5.48 5.92.42.36.81 1.1.81 2.22l-.01 3.29c0 .32.21.7.82.58A12 12 0 0 0 12 .3" />
      ) : kind === 'asana' ? (
        <>
          <circle cx="12" cy="6.5" r="4.5" />
          <circle cx="5.5" cy="16.5" r="4.5" />
          <circle cx="18.5" cy="16.5" r="4.5" />
        </>
      ) : (
        <path fillRule="evenodd" d="M5 2h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3Zm1 3.5v11.5h4.5V5.5H6Zm7.5 0V12H18V5.5h-4.5Z" />
      )}
    </svg>
  );
}
